export default "__VITE_ASSET__DVP3T9eU__"